import { render, staticRenderFns } from "./set-record.vue?vue&type=template&id=4dff90be&scoped=true"
import script from "./set-record.vue?vue&type=script&lang=js"
export * from "./set-record.vue?vue&type=script&lang=js"
import style0 from "./set-record.vue?vue&type=style&index=0&id=4dff90be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dff90be",
  null
  
)

export default component.exports